(function($) {
    function myFunction(x) {
        if (x.matches) { // If media query matches

            var maxHeight = 430;

            $(function(){

                $(".sub-menu-wrapper-1 > .sub-menu > .menu-item").hover(function() {

                    var $container = $(this),
                        $list = $container.find(".sub-menu-wrapper-2"),
                        $subList = $list.find(".sub-menu"),
                        $numberChildren = $subList.children().length,
                        $anchor = $container.find("a"),
                        height = $list.height() * 1.1,       // make sure there is enough room at the bottom
                        multiplier = height / maxHeight;     // needs to move faster if list is taller

                    // need to save height here so it can revert on mouseout
                    $container.data("origHeight", $container.height());

                    // so it can retain it's rollover color all the while the dropdown is open
                    $anchor.addClass("js-hover");

                    // make sure dropdown appears directly below parent list item
                    $subList
                        .show();
                    /*.css({
                        paddingTop: $container.data("origHeight")
                    });*/

                    // don't do any animation if list shorter than max
                    if ($numberChildren > 9) {
                        $container
                            .css({
                                /*height: maxHeight,*/
                                overflow: "hidden"
                            })
                            .mousemove(function(e) {
                                var offset = $container.offset();
                                console.log(offset, e.pageY, (e.pageY - offset.top));
                                var relativeY = ((e.pageY - offset.top) * multiplier) - ($container.data("origHeight") * multiplier);
                                if (relativeY > $container.data("origHeight")) {
                                    //$list.css("top", -relativeY + $container.data("origHeight"));
                                    $subList.css("top", -relativeY + $container.data("origHeight"));
                                }
                                console.log(relativeY, offset);
                            });
                        $subList
                            .mousemove(function(e){
                                $list.css("top", 80);
                            });
                    }

                }, function() {

                    var $el = $(this);

                    // put things back to normal
                    $el
                        .height($(this).data("origHeight"))
                        .find(".sub-menu-wrapper-2 > .sub-menu")
                        .css({ top: 0 })
                        .hide()
                        .end()
                        .find("a")
                        .removeClass("js-hover");

                });

                // Add down arrow only to menu items with submenus
                /*$(".dropdown > li:has('ul')").each(function() {
                    $(this).find("a:first").append("<img src='images/down-arrow.png' />");
                });*/

            });

        }
    }

    var x = window.matchMedia("(min-width: 992px)")
    myFunction(x) // Call listener function at run time
    x.addListener(myFunction) // Attach listener function on state changes

})(jQuery);

